import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map, tap, catchError, shareReplay } from 'rxjs/operators';

import { WindowRefService } from '../../../../services/window-ref.service';
import { SessionStorageService } from '../../../../services/web-storage/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ContentVersioningService {
  protected dataStoreKey = 'maContentVersion';

  private contentVersionObservable: Observable<string>;

  constructor(
    private http: HttpClient,
    private windowRefService: WindowRefService,
    private sessionStorageService: SessionStorageService
  ) {}

  getVersion(contentId: string): Observable<string> {
    return this.getVersions().pipe(
      map((source: any) => {
        return this.findContentVersion(contentId, source);
      })
    );
  }

  getVersions(): Observable<any> {
    const storageValue = this.sessionStorageService.getItem(this.dataStoreKey, true);

    if (storageValue) {
      return of(storageValue);
    }

    if (this.contentVersionObservable) {
      return this.contentVersionObservable;
    }

    const url = this.getFullApiUrl();

    this.contentVersionObservable = this.http.get(url).pipe(
      map((resp: any) => {
        return resp && resp.resources;
      }),
      tap((versionInfos: any) => {
        this.sessionStorageService.setItem(this.dataStoreKey, versionInfos, true);
      }),
      catchError((error: any) => {
        return of({});
      }),
      shareReplay(1)
    );

    return this.contentVersionObservable;
  }

  private getFullApiUrl(): string {
    return this.windowRefService.nativeWindow.environment.CONTENT_CDN_URL +
           '/mypru/v1/config/api-list.json';
  }

  private findContentVersion(contentId: string, source: any): string {
    const defaultVersion = '0';

    if (!source) {
      return defaultVersion;
    }

    const foundMatches: any[] = Object.keys(source).filter(item => {
      return item && item.indexOf(contentId) > 0;
    });

    if (foundMatches && foundMatches.length > 0) {
      return source[foundMatches[0]].v;
    }

    return defaultVersion;
  }
}
